import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconCopy: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconCopy" {...props}>
    <svg height="100%" viewBox="0 0 12 12" fill="currentColor">
      <g>
        <path
          fillRule="evenodd"
          d="M8.625 1.875c.41422 0 .75.33579.75.75v8.625c0 .4142-.33578.75-.75.75H1.5c-.41421 0-.749996-.3358-.749996-.75V2.625c0-.41421.335786-.75.749996-.75h7.125zm0 .75H1.5v8.625h7.125V2.625z"
          clipRule="evenodd"
        />
        <path d="M10.5 0c.4142 0 .75.335786.75.75v9c0 .20711-.1875.3799-.375.375-.1875-.0049-.375-.1875-.375-.375v-9H3s-.375 0-.375-.375S3 0 3 0h7.5z" />
      </g>
    </svg>
  </IconSVG>
)

export default IconCopy
